export default class InventoryReasons {
  constructor({ Id, motivo }) {
    this.id = Id
    this.motivo = motivo
  }

  static fromPrimitives(primitives) {
    return new InventoryReasons(primitives)
  }

  toPrimitives() {
    return {
      id: this.id,
      motivo: this.motivo
    }
  }
}
